<template>
  <div
    class="w-full p-4 border-t-8 bg-gray-200"
    :style="{ borderColor: `#${primaryColor}` }"
  >
    <div class="flex justify-center p-4">
      <div class="grid md:grid-cols-3 w-[64rem] gap-y-8 gap-x-4">
        <div>
          <img
            v-if="config.footer?.logo_url"
            class="h-[4rem] object-contain"
            :src="config.footer?.logo_url"
            alt="Logo"
          >
          <img
            v-else-if="isPreview()"
            class="h-[4rem] object-contain"
            src="https://placehold.co/190x60"
            alt="Image"
          >
        </div>

        <div>
          <p
            class="font-semibold text-lg"
            :style="{ color: `#${primaryColor}` }"
          >
            {{ __('pre_lander_001_footer_contact_info') }}
          </p>
          <!-- eslint-disable vue/no-v-html -->
          <div v-html="config.footer?.contact_info" />
        </div>

        <div class="grid gap-y-2">
          <div
            v-if="config.footer?.email"
            class="inline-flex"
          >
            <img
              class="w-5 h-5 object-contain mr-2"
              src="@timon/js/Templates/PRE-LANDER-001/assets/icon-mail.svg"
              alt="Mail"
            >

            <a
              :href="`mailto:${config.footer.email}`"
              target="_blank"
              class="underline"
            >
              {{ config.footer.email }}
            </a>
          </div>

          <div
            v-if="config.footer?.facebook_name"
            class="inline-flex"
          >
            <img
              class="w-5 h-5 object-contain mr-2"
              src="@timon/js/Templates/PRE-LANDER-001/assets/icon-facebook.svg"
              alt="Facebook"
            >

            <a
              v-if="config.footer?.facebook_link"
              :href="config.footer?.facebook_link"
              class="underline"
              target="_blank"
            >
              {{ config.footer.facebook_name }}
            </a>
            <p v-else>
              {{ config.footer.facebook_name }}
            </p>
          </div>

          <div
            v-if="config.footer?.messenger_name"
            class="inline-flex"
          >
            <img
              class="w-5 h-5 object-contain mr-2"
              src="@timon/js/Templates/PRE-LANDER-001/assets/icon-messenger.svg"
              alt="Messenger"
            >

            <a
              v-if="config.footer?.messenger_link"
              :href="config.footer?.messenger_link"
              class="underline"
              target="_blank"
            >
              {{ config.footer.messenger_name }}
            </a>
            <p v-else>
              {{ config.footer.messenger_name }}
            </p>
          </div>
        </div>

        <div class="md:col-span-3">
          <p
            class="font-semibold text-lg"
            :style="{ color: `#${primaryColor}` }"
          >
            {{ __('pre_lander_001_footer_about_us') }}
          </p>
          <!-- eslint-disable vue/no-v-html -->
          <div v-html="config.footer?.about_us" />
        </div>
      </div>
    </div>
  </div>

  <div class="w-full bg-black text-white text-center p-0.5 flex justify-center">
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-html="config.footer?.text"
    />
    <!-- eslint-enable vue/no-v-html -->
    <div
      v-for="(page, index) in pages"
      :key="index"
      class="ml-1 flex"
    >
      <p>-</p>
      <p
        class="underline ml-1 cursor-pointer"
        @click="router.get(pageUrl('PRE-LANDER-001', page.slug))"
      >
        {{ page.title }}
      </p>
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import {router} from '@inertiajs/vue3';
import {isPreview, pageUrl} from '@timon/js/Mixins/helpers';

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },

  collectorFlowUuid: {
    type: String,
    required: true,
  },

  pages: {
    type: Array,
    required: true,
  },
});

const primaryColor = ref(props.config.style?.primary);
</script>
